<script setup lang="ts">
import { useAddressBookStore } from '@/store/addressBook';
import { getAddressSystemLogo } from '@/helpers/getAddressSystemLogo';

const addressBookStore = useAddressBookStore();
defineProps<{
  density: 'compact' | 'default';
}>();
</script>

<template>
  <v-list
    v-if="addressBookStore.recentItems.length > 0"
    :density="density"
    nav
    class="recent-wallets"
  >
    <v-list-subheader>Recent Wallets</v-list-subheader>
    <v-list-item
      v-for="item in addressBookStore.recentItems"
      class="rounded-lg"
      :prepend-avatar="getAddressSystemLogo(item.address)"
      :to="{
        name: 'Portfolio',
        params: {
          addresses: item.address,
        },
      }"
      :title="item.name"
    ></v-list-item>
  </v-list>
</template>
